<template>
  <CockpitLayout class="error-view" :class="{ '-loading': false }">
    <template v-if="is404">
      <TitleContainer
        title="Seite nicht gefunden"
        eyebrow="404"
      ></TitleContainer>
    </template>
    <template v-if="is403">
      <TitleContainer
        title="Sie haben keine Berechtigung"
        eyebrow="403"
      ></TitleContainer>
    </template>
  </CockpitLayout>
</template>

<script setup lang="ts">
import CockpitLayout from '~/cockpit/CockpitLayout.vue';
import { injectStrict } from '~/common/inject';
import { AppDataInjectionKey } from '~/common/useAppData';
import { computed } from 'vue';
import TitleContainer from '~/common/TitleContainer.vue';

const { data } = injectStrict(AppDataInjectionKey);

const is404 = computed(() => data.error === 'not-found');
const is403 = computed(() => data.error === 'forbidden');
</script>
